import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { HeadingProvider } from "./screens/app/AppHeading";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HeadingProvider>
      <RouterProvider router={router} />
    </HeadingProvider>
  </React.StrictMode>
);

